<template>
  <v-card
    v-intersect="read"
    color="special"
    class="notification-card mb-3"
    @click="
      $emit('navigateto', memberNotificationType, notificationAppointmentId)
    "
  >
    <v-chip
      v-if="!notificationRead"
      small
      rounded
      color="primary"
      class="font-weight-bold white--text new-chip"
      >{{ $t("sideNotificationMenu.notificationCard.chipLabel") }}</v-chip
    >
    <v-card-title class="pa-0">
      <v-icon left class="white--text mr-2 ml-0">{{ getIcon }}</v-icon>
      <span class="title font-weight-bold">
        {{ getTitle }}
      </span>
    </v-card-title>
    <v-card-title class="pa-0">
      <p class="text-uppercase mb-1">
        {{
          notification.creationDate
            | date("ddd DD MMMM YYYY - HH:mm", $i18n.locale)
        }}
      </p>
    </v-card-title>
    <v-card-text class="white--text pa-0">
      <p class="body-2 font-weight-medium mb-0" v-html="getText"></p>
    </v-card-text>
    <v-btn
      color="primary"
      class="notification-card-button font-weight-bold"
      rounded
      small
      depressed
      >{{ $t("moreInfo") }}</v-btn
    >
  </v-card>
</template>

<script>
export default {
  props: ["notification", "expanded"],
  data() {
    return {};
  },
  computed: {
    userInfo() {
      return this.$store.getters["login/userInfo"];
    },
    notificationId() {
      if (this.notification?.notificationId) {
        return this.notification.notificationId;
      }
      return null;
    },
    notificationAppointmentId() {
      if (this.notification?.appointmentId) {
        return this.notification.appointmentId;
      }
      return null;
    },
    notificationPortal() {
      if (this.notification?.portal) {
        return this.notification.portal;
      }
      return null;
    },
    memberNotificationType() {
      if (this.notification?.memberNotificationType) {
        return this.notification.memberNotificationType;
      }
      return null;
    },
    notificationAction() {
      if (this.notification?.notificationAction) {
        return this.notification.notificationAction;
      }
      return null;
    },
    notificationRead() {
      return this.notification.read;
    },
    getIcon() {
      let icons = {
        APPOINTMENT: "assignment_ind",
        MEMORANDUM: "fas fa-flag",
        CEILING: "fa-solid fa-hand-holding-hand"
        // ,REMINDER: "widgets"
      };
      return icons[this.memberNotificationType];
    },
    getTitle() {
      let notifTypeAction = `${this.notificationPortal}_${this.memberNotificationType}_${this.notificationAction}`;
      return this.$t(`notificationCenter.title.${notifTypeAction}`);
    },
    getText() {
      let notifTypeAction = `${this.notificationPortal}_${this.memberNotificationType}_${this.notificationAction}`;
      let suffixForText = null;
      let notifTypesForUserChannel = [
        "MEM_APPOINTMENT_NEW_APPOINTMENT_REQUEST",
        "MEM_APPOINTMENT_NEW_APPOINTMENT",
        "NESTPORTAL_APPOINTMENT_NEW_APPOINTMENT_REQUEST",
        "NESTPORTAL_APPOINTMENT_NEW_APPOINTMENT",
        "NESTPORTAL_APPOINTMENT_MODIFY_APPOINTMENT_REQUEST",
        "NESTPORTAL_APPOINTMENT_MODIFY_DATE",
        "NESTPORTAL_APPOINTMENT_ASK_FOR_NEW_DATE",
        "HFPORTAL_APPOINTMENT_SET_DATE",
        "HFPORTAL_APPOINTMENT_NEW_APPOINTMENT",
        "HFPORTAL_APPOINTMENT_MODIFY_DATE",
        "HFPORTAL_APPOINTMENT_MODIFY_SERVICE"
      ];
      if (notifTypesForUserChannel.includes(notifTypeAction)) {
        if (this.userInfo?.preferenzaContatto) {
          if (this.userInfo.preferenzaContatto === "S") {
            suffixForText = "SMS";
          }
          if (this.userInfo.preferenzaContatto === "E") {
            suffixForText = "EMAIL";
          }
        } else {
          // fallback if preferenzaContatto is null
          suffixForText = "EMAIL";
        }
      }
      let notificationText = `notificationCenter.text.${notifTypeAction}`;
      if (suffixForText && ["SMS", "EMAIL"].includes(suffixForText)) {
        notificationText = `${notificationText}_${suffixForText}`;
      }
      return this.$t(notificationText);
    }
  },
  methods: {
    read(entries, observer) {
      if (!this.notificationRead) {
        if (entries[0].isIntersecting) {
          this.$store.dispatch("notifications/markAsRead", this.notificationId);
        }
      }
    }
  }
};
</script>

<style scoped>
.notification-card {
  position: relative;
  padding: 15px !important;
  border-radius: 2px;
  box-shadow: unset;
  color: white !important;
  cursor: pointer;
  height: 100%;
}
.notification-card .v-card__title > p {
  font-size: 14px;
}
.new-chip {
  position: absolute;
  top: 8px;
  right: 8px;
  width: 65px;
  height: 23px;
}
.notification-card-button {
  position: absolute;
  bottom: 12px;
  right: 12px;
}
</style>
